/* JS to add click event listeners to the main menu `menu--main.html.twig` */
import getKeyboardFocusableElements from '../accessibility/getKeyboardFocusableElements';

let menuIsOpen = false;

function isHeaderOpen(header) {
  return header.classList.contains('header--open');
}

const toggleMobileMainNav = () => {
  if (
    document.getElementById('header')
    && document.getElementById('main-nav-burger')
  ) {
    menuIsOpen = !menuIsOpen;
    const header = document.getElementById('header');
    const burger = document.getElementById('main-nav-burger');
    const svgOpen = document.getElementById('svg--open');
    const svgClose = document.getElementById('svg--close');

    header.classList.toggle('header--open');
    burger.classList.toggle('main-nav-burger--open');
    burger.classList.toggle('main-nav-burger--closed');

    const brand = document.querySelector('.header__brand');
    if (brand) {
      brand.classList.toggle('header__brand--open');
      brand.classList.toggle('header__brand--closed');
    }

    const navigation = document.querySelector('.header__navigation');
    if (navigation) {
      navigation.classList.toggle('header__navigation--open');
      navigation.classList.toggle('header__navigation--closed');
    }

    const language = document.querySelector('.header__language');
    if (language) {
      language.classList.toggle('header__language--open');
      language.classList.toggle('header__language--closed');
    }

    const button = document.querySelector('.header__button');
    if (button) {
      button.classList.toggle('header__button--open');
      button.classList.toggle('header__button--closed');
    }

    /** Put no-scroll on the body */
    document.querySelector('body').classList.toggle('no-scroll');

    isHeaderOpen(header) ? svgClose.focus() : svgOpen.focus();
  }
};

const addMainNavToggleHandlers = () => {
  if (document.getElementById('main-nav-burger')) {
    const el = document.getElementById('main-nav-burger');
    el.addEventListener('click', (e) => {
      e.preventDefault();
      toggleMobileMainNav();
    });

    /** Add click for keyboard enter to improve keyboard accessibility */
    el.addEventListener('keyup', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        el.click();
      }
    });
  }
};

const addMobileNavAccordionHandlers = () => {
  const handlers = document.querySelectorAll('.navigation__chevron--mobile');
  [...handlers].forEach((element) => {
    element.addEventListener('click', () => {
      const parentItem = element.closest('.navigation__top-level-item');
      if (
        parentItem.classList.contains('navigation__top-level-item--expanded')
      ) {
        parentItem.classList.remove('navigation__top-level-item--expanded');
        parentItem.setAttribute('aria-expanded', false);
      } else {
        [
          ...document.querySelectorAll('.navigation__top-level-item--expanded'),
        ].forEach((item) => {
          item.classList.remove('navigation__top-level-item--expanded');
          item.setAttribute('aria-expanded', false);
        });
        parentItem.classList.add('navigation__top-level-item--expanded');
        parentItem.setAttribute('aria-expanded', true);
      }
    });
    /** Add click for keyboard enter to improve keyboard accessibility */
    element.addEventListener('keyup', (event) => {
      // Number 13 is the "Enter" key on the keyboard
      if (event.keyCode === 13 || event.keyCode === 32) {
        // Cancel the default action, if needed
        event.preventDefault();
        // Trigger the button element with a click
        element.click();
      }
    });
  });
};

export function initMenuMain() {
  addMainNavToggleHandlers();
  addMobileNavAccordionHandlers();

  const header = document.getElementById('header');

  /** For accessibilty, we trap tab focus within the menu modal */
  const focusables = getKeyboardFocusableElements(header);
  const firstEl = focusables[2];
  let lastEl = focusables[focusables.length - 1];
  // check if the last element is a sub item
  const isLastAnchor = lastEl.classList.contains('navigation__sub-item-anchor');

  window.addEventListener('keydown', (e) => {
    if (!isHeaderOpen(header)) return;

    if (e.key === 'Tab') {
      // get the last anchor item's parent.
      const lastParent = lastEl.closest('.navigation__top-level-item');
      // get the last anchor items's chevron.
      const chevron = lastParent.querySelector('.navigation__chevron--mobile');
      // check if the parent is expanded.
      const lastParentExpanded = lastParent.classList.contains('navigation__top-level-item--expanded');
      // if the sub item exists and the parent IS NOT expanded, make chevron the 'last element'
      // if the sub item exists and the parent IS expanded, default to the last 'focusable'.
      // if the sub item DOES NOT exist, default to the last 'focusable'.
      lastEl = isLastAnchor && !lastParentExpanded ? chevron : focusables[focusables.length - 1];

      // Leaving the first element with Tab : focus the last one
      if (document.activeElement === firstEl && e.shiftKey) {
        e.preventDefault();
        lastEl.focus();
      }
      // Leaving the last element with Tab : focus the first one
      if (document.activeElement === lastEl && !e.shiftKey) {
        e.preventDefault();
        firstEl.focus();
      }
    }
    if (e.key === 'Escape') {
      toggleMobileMainNav();
    }
  });
}

export default 'initMenuMain';
